import { useHistory } from 'react-router-dom';

import { setLoginAlert, setIsLoggedIn } from '../../../Session/actions';
import { loginAlerts } from '../../../Session/constants';
import { evvToken } from '../../../Common/constants';
import { setInStorage } from '../../../Common/utils';
import { useAction } from '../../../Common/hooks';
import { cleanFilters } from '../../actions';

const useHeaderMenu = () => {
  const history = useHistory();
  const dispatchIsLoggedIn = useAction(setIsLoggedIn);
  const dispatchAlert = useAction(setLoginAlert);
  const dispatchCleanFilters = useAction(cleanFilters);

  const logoutHandler = async () => {
    setInStorage(evvToken, '');
    dispatchIsLoggedIn({ isLoggedIn: false });
    dispatchAlert({ alertType: loginAlerts.successAlert, isVisible: true });
    dispatchCleanFilters();

    history.push('/login');
  };

  return {
    logoutHandler,
  };
};

export default useHeaderMenu;
